/**
 * Themed empty state block — uses the peak-empty CSS class which adapts
 * per theme (soft glow ring on dark themes, dashed border on light).
 * Usage: <EmptyState icon={Users} title="No contacts yet" hint="Import a CSV or add manually" />
 */
export default function EmptyState({ icon: Icon, title, hint, action, testId }) {
  return (
    <div className="peak-empty" data-testid={testId || "empty-state"}>
      {Icon && (
        <div className="peak-empty__icon">
          <Icon className="w-5 h-5" strokeWidth={2} />
        </div>
      )}
      {title && (
        <div className="text-[var(--peak-ink)] font-heading font-bold normal-case tracking-tight text-sm">
          {title}
        </div>
      )}
      {hint && <div className="mt-0.5">{hint}</div>}
      {action && <div className="mt-3">{action}</div>}
    </div>
  );
}
